module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/main-visual-07a84d5b73ed33fc9880e5e24963bbce.webp";